import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

import * as PouchDB from 'pouchdb/dist/pouchdb';
import * as PouchErase from 'pouchdb-erase'

PouchDB.plugin(PouchErase);

import { methodChooser} from './chart';

const savingsdb = new PouchDB('savings');
const transactionsdb = new PouchDB('transactions');
const cachedb = new PouchDB('cache');
const settingsdb = new PouchDB('settings');

savingsdb.changes({ live: true, since: 'now', include_docs: true}).on('change', (change) => {
  savingsdb.allDocs({ include_docs: true}).then(docs => {
    console.log(docs);
  });
});

transactionsdb.changes({ live: true, since: 'now', include_docs: true}).on('change', (change) => {
  transactionsdb.allDocs({ include_docs: true}).then(docs => {
    console.log(docs);
  });
});

cachedb.changes({ live: true, since: 'now', include_docs: true}).on('change', (change) => {
  cachedb.allDocs({ include_docs: true}).then(docs => {
    console.log(docs);
  });
});

settingsdb.changes({ live: true, since: 'now', include_docs: true}).on('change', (change) => {
  settingsdb.allDocs({ include_docs: true}).then(docs => {
    console.log(docs);
  });
});



const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
const today  = new Date();

Vue.use(Vuex)
export const store = new Vuex.Store({
  state: {
    isAuth: false,
    isLoading: false,
    isInFirstStage: false,
    type: '',
    message: '',
    // Whoever comes here must have a uid already
    userID: '',
    savingsArray: [],
    transactionsArray: [],
    namesArray: [],
    inputsArray: [],
    fullObject: '',
    currentPlan: '',
    currentSavingsIndex: 0,
    currentTransactionsIndex: 0,
    //Settings
    lightTheme: true
  },
  mutations: {
    clearArrays: function(state){
      state.savingsArray = [];
      state.transactionsArray = [];
      state.namesArray = [];
      state.inputsArray = [];
      state.fullObject = '';
    },
    setNewSavingsArrays: function(state, payload){
      state.savingsArray = payload.savingsArray;
      state.namesArray = payload.namesArray;
      state.inputsArray = payload.inputsArray;
      state.currentSavingsIndex = payload.lastSavingIndex;

    },
    setTransactionArrays: function(state, payload){
      state.transactionsArray = payload.transactionsArray;
      state.currentTransactionsIndex = payload.currentTransactionsIndex;
      // Set chart after the settings
    },
    settingsClear: function(state, payload = null) {


      if(!payload){
        let inputsArray = [...state.inputsArray];
        let namesArray = [...state.namesArray];

        if(inputsArray.length > 0){

          if(state.currentPlan === ''){
            state.currentPlan = 'conservative';
          }

          let chartObject = methodChooser(state.currentPlan, inputsArray,namesArray);
          state.fullObject = chartObject;
        } else {
          state.fullObject = '';
        }
        return
      }

      console.log('Reached here');
      // Meaning there is payload
      state.currentPlan = payload.plan;
      state.lightTheme = payload.lightTheme;

      let inputsArray = [...state.inputsArray];
      let namesArray = [...state.namesArray];

      if(inputsArray.length > 0){
        let chartObject = methodChooser(state.currentPlan, inputsArray,namesArray);
        state.fullObject = chartObject;
      } else {
        state.fullObject = '';
      }

    },
    changeTheme: function(state, payload){
      state.lightTheme = payload;
    },
    changePlan: function(state, payload){
      state.currentPlan = payload;

      // Change calculations with this
      let inputsArray = [...state.inputsArray];
      let namesArray = [...state.namesArray];

      console.log(inputsArray);
      console.log(namesArray);

      inputsArray = inputsArray.map(Number);

      console.log(inputsArray);

      if(inputsArray.length > 0){
        let chartObject = methodChooser(state.currentPlan, inputsArray,namesArray);
        state.fullObject = chartObject;
      } else {
        state.fullObject = '';
      }

    },
    changeChartObject: function(state, payload){
      state.fullObject = payload;
    },
    adjustPlan: function(state, payload){
      state.currentPlan = payload;
    },
    deleteRecord: function(state, payload){

      let index = state.namesArray.indexOf(payload.name);

      // console.log(index);

      state.inputsArray.splice(index*2,2);

      // console.log(state.inputsArray);

      console.log(state.namesArray);
      state.namesArray = state.namesArray.filter(name => {
        return name !== payload.name;
      })

      console.log(state.namesArray);

      state.savingsArray = state.savingsArray.filter(savings => {
        return savings._id !== payload._id;
      })

      // console.log(state.savingsArray);

      state.transactionsArray = state.transactionsArray.filter(transaction => {
        return transaction.name !== payload.name;
      })

      // console.log(state.transactionsArray);

      let inputsArray = [...state.inputsArray];
      let namesArray = [...state.namesArray];

      if(inputsArray.length > 0){
        let chartObject = methodChooser(state.currentPlan, inputsArray,namesArray);
        state.fullObject = chartObject;
      } else {
        state.fullObject = '';
      }

    },
    setSavingsIndex: function(state, payload){
      state.currentSavingsIndex = payload;
    },
    setTransactionsIndex: function(state, payload){
      state.currentTransactionsIndex = payload;
    },

    addSavings: function(state, payload){
        console.log(payload);
        state.savingsArray.push(payload);
    },
    addUpdatedSavings: function(state, payload){
        let objIndex = state.savingsArray.findIndex((obj => obj._id === payload._id));

      state.savingsArray[objIndex].lastTransactionType = payload.lastTransactionType;
      state.savingsArray[objIndex].lastTransactionAmount = payload.lastTransactionAmount;
      state.savingsArray[objIndex].lastTransactionDate = payload.lastTransactionDate;
      state.savingsArray[objIndex].lastTransactionID = payload.lastTransactionID;
      state.savingsArray[objIndex].prevAmount = payload.prevAmount;
      state.savingsArray[objIndex].currentAmount = payload.currentAmount;

    },
    addTransactions: function(state, payload){
      state.transactionsArray.push(payload);

      let inputsArray = [...state.inputsArray];
      let namesArray = [...state.namesArray];

      let chartObject = methodChooser(state.currentPlan, inputsArray,namesArray);
      state.fullObject = chartObject;

    },
    addInputs: function(state, payload){
      state.namesArray.push(payload.name);
      state.inputsArray.push(payload.current, payload.target);
    },
    changeUID: function(state, payload){
      state.userID = payload;
    },
    setUser: function ({state}, payload) {
      state.user = payload
    },
    logout: function ({state}) {
      return new Promise(resolve => {
        state = {
          isAuth: false,
          isLoading: false,
          isInFirstStage: false,
          type: '',
          message: '',
          // Whoever comes here must have a uid already
          userID: '',
          savingsArray: [],
          transactionsArray: [],
          namesArray: [],
          inputsArray: [],
          fullObject: '',
          currentPlan: '',
          currentSavingsIndex: 0,
          currentTransactionsIndex: 0,
          //Settings
          lightTheme: true
        }
      savingsdb.erase().then(() => {
        transactionsdb.erase().then(() => {
          settingsdb.erase().then(() => {
            settingsdb.erase().then(() => {
               resolve('Done');
            })
          })
        })
      })
      });
    },
    changeAuthStatus: function (state, payload) {
      if (typeof (payload) === 'boolean') {
        state.isAuth = payload
      }
    },
    stage1True: function (state) {
      state.isInFirstStage = true
    },
    stage1False: function (state) {
      state.isInFirstStage = false
    },
    changeLoadingState: function (state) {
      state.isLoading = false
    },
    showMessageDialog: function (state, payload) {
      state.type = payload.type
      state.message = payload.message
      state.isLoading = true
    }
  },
  actions: { // Can be async
    clearData: function({state, dispatch}){

      let savingsArray = state.savingsArray;

      savingsArray.forEach((saving) => {
         dispatch('delete', saving);
      });

    },
    uploadData: function({state}){

      cachedb.allDocs({ include_docs: true }).then((docs) => {
        if(docs.rows.length === 0) {
          console.log('There"s nothing in the cache!!!');
          return;
        }

        let documents = docs.rows;

        console.log(documents);

        documents.forEach((row, index, array) => {
          let cacheID = row.doc._id.slice();
          let request = row.doc.request;
          let obj = Object.assign({}, row.doc);
          delete obj['_rev'];



          // Object id reset

          // obj._id = this.getID(obj._id, type, request);


          if(cacheID.includes('savings')  || cacheID.includes('transactions')){
             let type;
            if(cacheID.includes('savings')){
              obj._id = obj._id.replace('_savings','') /// Problem can be here
              type = 'savings';
            } else {
              obj._id = obj._id.replace('_transactions','') /// Problem can be here
              type = 'transactions';
            }


              if(request === 'add') {

              obj._id = obj._id.replace('add_','');


              // console.log(obj);
              firebase.database().ref(`/${state.userID}/${type}/${obj._id}/`).set(obj).then(() => {
                console.log(`SYNC: Just sent your ${type} object to firebase!!! from cache`);
                // Delete object from cache
                  cachedb.get(cacheID).then(doc => {
                  return cachedb.remove(doc);
                }).then(() => {
                  console.log(`SYNC:  Just removed the ${type} object put earlier - cachedb`);
                }).catch(() => {
                  console.log(`SYNC:  Failed to remove the ${type} object put earlier`);
                })
              });
            } else if(request === 'update' && type === 'savings') {

               obj._id = obj._id.replace('update_','');// Problem was here

              firebase.database().ref(`/${state.userID}/savings/${obj._id}/`).update({
                lastTransactionType: obj.lastTransactionType,
                lastTransactionAmount: obj.lastTransactionAmount,
                lastTransactionDate: obj.lastTransactionDate,
                lastTransactionID: obj.lastTransactionID,
                prevAmount: obj.prevAmount,
                currentAmount: obj.currentAmount
              }).then(() => {
                // When successful, delete from cachedb
                 cachedb.get(cacheID).then(doc => {
                  return cachedb.remove(doc);
                }).then(() => {
                  console.log('SYNC : Just deleted cache update object after sending to firebase');
                }).catch(err => {
                  console.log('SYNC : Failed to delete update cache object after sending to firebase');
                });
              });
            } else if(request === 'delete' && type === 'savings') {

              obj._id = obj._id.replace('delete_','');

              firebase.database().ref(`/${state.userID}/savings/`).child(obj.realID).remove().then(() => {

                firebase.database().ref(`/${state.userID}/`).child('transactions').orderByChild('name').equalTo(obj.name).once('value', function(snapshot) {
                  let data = snapshot.val();

                  data.forEach((item, index, array) => {
                    let key = item.key;
                    firebase.database().ref(`/${state.userID}/transactions/`).child(key).remove().then(() => {
                      if(index === array.length) {
                        cachedb.get(cacheID).then(doc => {
                          return cachedb.remove(doc)
                        }).then(() => {
                          console.log('SYNC: Successful Cached delete request deleted after deleting from firebase');
                        }).catch(err => {
                          console.log( 'SYNC: Cached delete request failed after deleting from firebase');
                        });
                      }
                    });
                  })
                });
              });
            }

          } else { // type is settings

            console.log(obj);

            firebase.database().ref(`/${state.userID}/settings/`).set({
              lightTheme: obj.lightTheme,
              plan: obj.plan
            }).then(() => {
               cachedb.get(cacheID).then(doc => {
                return  cachedb.remove(doc);
              }).catch(err => {
                console.log('SYNC: Cached settings object was not removed');
              });
            });
          }
        });

      })

    },
    clearSavingsDB: function(){
      return new Promise(resolve => {
        savingsdb.erase().then(() => {
          resolve('Done');
        })
      });
    },
    clearTransactionsDB: function(){
      return new Promise(resolve => {
        transactionsdb.erase().then(() => {
          resolve('Done');
        })
      });
    },
    clearSettingsDB: function(){
      return new Promise(resolve => {
        settingsdb.erase().then(() => {
          resolve('Done');
        })
      });
    },
    downloadData: function({state,commit,dispatch}){

      firebase.database().ref(`/${state.userID}/savings/`).once('value').then(snapshot => {
        if (!snapshot.val()) {
          // If there are no documents
           dispatch('downloadTransactions');
          return;
        }
        dispatch('clearSavingsDB').then(() => {

          let collection = snapshot.val(); /// Deal with this

          collection = collection.filter(function(e) {
            return e;
          });

          collection.forEach((obj, index, array) => {
            let rObj = {
              _id: obj._id,
              name: obj.name,
              currentAmount: Number(obj.currentAmount),
              prevAmount: Number(obj.prevAmount),
              targetAmount: Number(obj.targetAmount),
              currentAdvise: obj.currentAdvise,
              adviseType: obj.adviseType,
              lastTransactionType: obj.lastTransactionType,
              lastTransactionAmount: Number(obj.lastTransactionAmount),
              lastTransactionDate: obj.lastTransactionDate
            };
            /// By now everything was cleared
            savingsdb.put(rObj);

            if (index === array.length - 1) {
              dispatch('downloadTransactions');
            }
          });

        });

      })
    },
    downloadTransactions: function({state,commit,dispatch}){

      firebase.database().ref(`/${state.userID}/transactions/`).once('value').then(snapshot => {

        if (!snapshot.val()) {
          // If there are no documents
          dispatch('downloadSettings');
          return;
        }
        dispatch('clearTransactionsDB').then(() => {
          let collection = snapshot.val(); /// Deal with this

          collection = collection.filter(function(e) {
            return e;
          });

          collection.forEach((obj, index, array) => {
            let rObj = {
              _id: obj._id,
              name: obj.name,
              transactionID: obj.transactionID,
              transactionAmount: obj.transactionAmount,
              transactionType: obj.transactionType,
              transactionDate: obj.transactionDate,
              current: obj.current,
              prev: obj.prev,
              target: obj.target
            };
            /// By now everything was cleared
            transactionsdb.put(rObj);

            if (index === array.length - 1) {
              dispatch('downloadSettings');
            }
          });
        });

      })
    },
    downloadSettings: function({state,commit,dispatch}){

      firebase.database().ref(`/${state.userID}/settings/`).once('value').then((snapshot) => {
        if (!snapshot.val()) {
          // If there are no documents
          // this.loadingService.dismissLoader();
          return;
        }
        dispatch('clearSettingsDB').then(() => {
          let settingsObject = snapshot.val();

          settingsObject._id = 'settings';

          setTimeout(()=> {
            settingsdb.put(settingsObject).then(() => {
              dispatch('loadData');
            }).catch((err) => {
              // dispatch('loadData');
              console.log(err);
            });
          },1200);
        });

      });
    },
    loadData: function({state, commit, dispatch}){
      // Loads data from pouchdb and updates the store
      savingsdb.allDocs({include_docs: true}).then(docs => {

        // this.inputsArray = [];
        // this.inputNameArray = [];
        // this.savingsArray = [];
        // this.lastIndex = 0;
        commit('clearArrays');

        if(docs.rows.length === 0) {
          // Work on this later
          dispatch('loadTransactions');
          return
        }

        let namesArray = [];
        let inputsArray = [];

        let lastIndex = Number(state.currentSavingsIndex);


        let array = docs.rows.map(row => {

          // this.inputNameArray.push(row.doc.name);
          namesArray.push(row.doc.name);
          // this.inputsArray.push(row.doc.currentAmount, row.doc.targetAmount);
          inputsArray.push(Number(row.doc.currentAmount), Number(row.doc.targetAmount));

          // this.lastIndex = (Number(row.doc._id) > this.lastIndex)? Number(row.doc._id) : this.lastIndex;
          lastIndex = (Number(row.doc._id) > lastIndex)? Number(row.doc._id) : lastIndex;

          let rObj = {
            _id: row.doc._id,
            name: row.doc.name,
            dateAdded: row.doc.dateAdded,
            adviseType: row.doc.adviseType,
            currentAdvise: row.doc.currentAdvise ,
            lastTransactionType: row.doc.lastTransactionType,
            lastTransactionAmount: Number(row.doc.lastTransactionAmount),
            lastTransactionDate: row.doc.lastTransactionDate,
            lastTransactionID: row.doc.lastTransactionID,
            prevAmount: Number(row.doc.prevAmount),
            currentAmount: Number(row.doc.currentAmount),
            targetAmount: Number(row.doc.targetAmount)
          }
          return rObj;
        });

        let payload = {
          savingsArray: array,
          namesArray,
          inputsArray,
          lastSavingIndex: lastIndex
        }

        commit('setNewSavingsArrays', payload);
        dispatch('loadTransactions');

      });

    },
    loadTransactions: function({commit, state, dispatch}){

      transactionsdb.allDocs({include_docs : true}).then(docs => {
        if(docs.rows.length === 0){
          dispatch('loadSettings');
          return
        }

        let lastTransactionIndex = Number(state.currentTransactionsIndex);

        let array = docs.rows.map(row => {

          lastTransactionIndex = (Number(row.doc._id) > lastTransactionIndex)? Number(row.doc._id) : lastTransactionIndex;

          let rObj = {
            _id: row.doc._id,
            name: row.doc.name,
            transactionType: row.doc.transactionType,
            transactionAmount: row.doc.transactionAmount,
            transactionDate: row.doc.transactionDate,
            transactionID: row.doc.transactionID,
            prev: row.doc.prev,
            current: row.doc.current,
            target: row.doc.target
          }
          return rObj;
        });

        let payload = {
          transactionsArray: array,
          currentTransactionsIndex: lastTransactionIndex
        }

        commit('setTransactionArrays', payload)
        dispatch('loadSettings');

      });

    },
    loadSettings: function({commit, state}){

      settingsdb.get('settings').then(doc => {
        // If settings found

        let payload = {
          lightTheme: doc.lightTheme,
          plan: doc.plan
        }

        console.log(doc);
        commit('settingsClear', payload);

      }).catch(err => {

        if(state.inputsArray.length > 0){
          commit('settingsClear', 'conservative');
        } else {
          commit('settingsClear')
        }



        console.log(`You have no settings currently`);
      });

    },
    changeTheme: function({commit, state, dispatch}, payload){
      commit('changeTheme', payload);

      let plan = state.currentPlan;

      settingsdb.get('settings').then(doc => {
          doc.lightTheme = payload;
          settingsdb.put(doc).then(() => {
            dispatch('updateSettingsOnFirebase')
          }).catch(err => {
            console.log(err);
          }); // Assuming all is well

      }).catch(err => {
        // Meaning the doc did not exist
        let settingsObject = {
          _id: 'settings',
          lightTheme: payload,
          plan
        }
        settingsdb.put(settingsObject).then(() => {
          dispatch('updateSettingsOnFirebase')
        }).catch(err => {
          console.log(err);
        })

      })

    },
    changePlan: function({commit, state, dispatch}, payload){
      commit('changePlan', payload);

      let lightTheme = state.lightTheme;


      settingsdb.get('settings').then(doc => {
        doc.plan = payload;
        console.log(doc);

        settingsdb.put(doc, {allow_conflict: true}).then(() => {
          dispatch('updateSettingsOnFirebase')
        }).catch(err => {
          console.log(err);
        }); // Assuming all is well
      }).catch(err => {
        // Meaning the doc did not exist
        let settingsObject = {
          _id: 'settings',
          lightTheme,
          plan : payload
        }
        settingsdb.put(settingsObject, {allow_conflict: true}).then(() => {
          dispatch('updateSettingsOnFirebase')
        }).catch(err => {
          console.log(err);
        });;

      })

    },
    updateSettingsOnFirebase: function({state}){

      let settingsObject = {
        _id: 'settings',
        plan: state.currentPlan,
        lightTheme: state.lightTheme
      }

      cachedb.get(settingsObject._id).then(doc => {

        doc.plan = settingsObject.plan;
        doc.lightTheme = settingsObject.lightTheme;

        cachedb.put(doc).then(() => {

          firebase.database().ref(`/${state.userID}/settings/`).update({
            plan: settingsObject.plan,
            lightTheme: settingsObject.lightTheme
          }).then(() => {
            cachedb.get('settings').then(doc2 => {
              console.log(doc2);
              return cachedb.remove(doc2)
            }).then().catch(err => {
              console.log(err);
            })
          })

        }).catch(err => {
          console.log(err);
        });

      }).catch(err => {
        cachedb.put(settingsObject).then(() => {

          firebase.database().ref(`/${state.userID}/settings/`).update({
            plan: settingsObject.plan,
            lightTheme: settingsObject.lightTheme
          }).then(() => {
            cachedb.get('settings').then(doc2 => {
              cachedb.remove(doc2)
            })
          })

        });
      });


    },
    setChartObject: function({commit, state}, payload){
      let inputsArray = [...state.inputsArray];
      let namesArray = [...state.namesArray];

      let chartObject = methodChooser(payload, inputsArray,namesArray);
      commit('changeChartObject',chartObject);
    },
    adjustPlan: function ({commit}, payload){
      commit('adjustPlan', payload);
    },
    fetchInfo: function({state}){
      return {
        savings: [...state.savingsArray],
        transactions: [...state.transactionsArray]
      }
    },
    updateSavings: function ({commit, state, dispatch}, payload){
      // Get savings array  object from state with same name
      let savingsArray = [...state.savingsArray];


      console.log(payload);
      let savingsObject = savingsArray.filter(obj => {
           return obj.name === payload.name;
      });

      savingsObject = {...savingsObject[0]};

      // Put the object through cachedb
      let dateToday = today.toLocaleDateString("en-US", options);

      savingsObject.lastTransactionType = payload.type;
      savingsObject.lastTransactionAmount = payload.amount;
      savingsObject.lastTransactionDate = dateToday;
      savingsObject.lastTransactionID = payload.transactionCode;

      savingsObject.prevAmount = savingsObject.currentAmount;

      if(payload.type === 'deposit') {
        savingsObject.currentAmount =  Number(savingsObject.currentAmount) + Number(payload.amount);
      } else {
        savingsObject.currentAmount =  Number(savingsObject.currentAmount) - Number(payload.amount);
      }

      //Update inputs array
      let index = savingsArray.findIndex(obj => obj.name === payload.name);

      state.inputsArray[((index*2))] =  savingsObject.currentAmount;

      let transactionsObject = {
        _id: String(state.currentTransactionsIndex + 1),
        name: savingsObject.name,
        transactionType: savingsObject.lastTransactionType,
        transactionDate: dateToday,
        transactionID: savingsObject.lastTransactionID,
        transactionAmount: savingsObject.lastTransactionAmount,
        prev: savingsObject.prevAmount,
        current: savingsObject.currentAmount,
        target: savingsObject.targetAmount
      };

      // Increment the transactions index
      commit('setTransactionsIndex', (state.currentTransactionsIndex + 1));

      let cacheSavingsID = `update_savings_${savingsObject._id}`;
      let cacheTransactionsID = `add_transactions_${transactionsObject._id}`;

      let cacheSavingsObject = {...savingsObject};
      cacheSavingsObject._id = cacheSavingsID;
      cacheSavingsObject.request = 'update';

      let cacheTransactionsObject = {...transactionsObject};
      cacheTransactionsObject._id = cacheTransactionsID;
      cacheTransactionsObject.request = 'add';


     cachedb.get(cacheSavingsObject._id).then(doc => {
       doc.lastTransactionType = cacheSavingsObject.lastTransactionType;
       doc.lastTransactionAmount = cacheSavingsObject.lastTransactionAmount;
       doc.lastTransactionDate = cacheSavingsObject.lastTransactionDate;
       doc.lastTransactionID = cacheSavingsObject.lastTransactionID;

       doc.prevAmount = cacheSavingsObject.prevAmount;
       doc.currentAmount = cacheSavingsObject.currentAmount;

       cachedb.put(doc).then(() => {
         commit('addUpdatedSavings', savingsObject);

        /// Continue with transactions addition
         cachedb.put(cacheTransactionsObject).then(() => {
           console.log(`Successfully put ${cacheTransactionsObject.name} : transaction in cachedb`);
           commit('setTransactionsIndex', state.currentTransactionsIndex + 1);
           commit('addTransactions', transactionsObject);
           /// Put in transactionsdb
           transactionsdb.put(transactionsObject).then(() => {
             console.log(`Successfully placed ${transactionsObject.name} in transactionsdb`);

             ///// Update chartObject
             const plan = state.currentPlan;
             dispatch('setChartObject', plan);


             firebase.database().ref(`/${state.userID}/transactions/${transactionsObject._id}/`).set(transactionsObject).then(() => {

               cachedb.get(cacheTransactionsObject._id).then(doc => {
                 cachedb.remove(doc).then(() => {
                   console.log(`Successfully deleted transactions cache object ${cacheTransactionsObject.name} from cache db`)
                 }).catch(err => {
                   console.log(`Failed to delete transactions cache object ${cacheTransactionsObject.name} from cache db`)
                 });
               }).catch(err => {
                 console.log(`Failed to delete transactions cache object: ${cacheTransactionsObject.name} from cache db`);
               });

             }).catch(err => {

               console.log(`Failed to add ${transactionsObject.name} : transaction in firebase transactions' node`);


             });
           }).catch(err => {
             console.log(`Failed to place ${transactionsObject.name} in transactionsdb`);
           });

         }).catch(err => {
           console.log(`Failed to put ${cacheTransactionsObject.name} in cachedb`);
         });

       }).catch(err => {
         console.log(`Failed to update the found cacheSavingsObject ${cacheSavingsObject.name} ${err}`);
       })

     }).catch(err => {
       /// The cached Savings object does not exist
       console.log(`Cache updateSavings object was not found, adding a new one ${err}`);
       cachedb.put(cacheSavingsObject).then(() => {
         console.log(`Successfully put the savings update object ${cacheSavingsObject.name} in cachedb`);

         savingsdb.get(savingsObject._id).then(doc => {
           doc.lastTransactionType = savingsObject.lastTransactionType;
           doc.lastTransactionAmount = savingsObject.lastTransactionAmount;
           doc.lastTransactionDate =  savingsObject.lastTransactionDate;
           doc.lastTransactionID =  savingsObject.lastTransactionID;

           doc.prevAmount = savingsObject.prevAmount;
           doc.currentAmount = savingsObject.currentAmount;

           savingsdb.put(doc).then(() => {
             console.log(`Successfully updated the ${savingsObject.name} savings object in the savings db`);
             commit('addUpdatedSavings', savingsObject);

             firebase.database().ref(`/${state.userID}/savings/${savingsObject._id}/`).update({
               lastTransactionType : savingsObject.lastTransactionType,
               lastTransactionAmount : savingsObject.lastTransactionAmount,
               lastTransactionDate : savingsObject.lastTransactionDate,
               lastTransactionID : savingsObject.lastTransactionID,
               prevAmount : savingsObject.prevAmount,
               currentAmount : savingsObject.currentAmount
             }).then(() => {
               console.log(`Successfully updated ${savingsObject.name} in firebase`);

               cachedb.get(cacheSavingsObject._id).then(doc => {

                 cachedb.remove(doc).then(() => {
                   console.log(`Successfully removed update cache savings object ${savingsObject.name} from cachedb after adding it to firebase`);
                 }).catch(() => {
                   console.log(`Failed to remove update cache savings object ${savingsObject.name} from cachedb after adding it to firebase`);
                 });
               }).catch(err => {
                 console.log(`Failed to get the cached update savings object ${cacheSavingsObject.name} from cachedb`);
               });
             }).catch(err => {
               console.log(`Failed to update the savingsObject ${savingsObject.name} in firebase ${err}`)
             });


             /// Transactions
             cachedb.put(cacheTransactionsObject).then(() => {
               console.log(`Successfully put ${cacheTransactionsObject.name} : transaction in cachedb`);
               commit('setTransactionsIndex', state.currentTransactionsIndex + 1);
               commit('addTransactions', transactionsObject);
               /// Put in transactionsdb
               transactionsdb.put(transactionsObject).then(() => {
                 console.log(`Successfully placed ${transactionsObject.name} in transactionsdb`);

                 ///// Update chartObject
                 const plan = state.currentPlan;
                 dispatch('setChartObject', plan);


                 firebase.database().ref(`/${state.userID}/transactions/${transactionsObject._id}/`).set(transactionsObject).then(() => {

                   cachedb.get(cacheTransactionsObject._id).then(doc => {
                     cachedb.remove(doc).then(() => {
                       console.log(`Successfully deleted transactions cache object ${cacheTransactionsObject.name} from cache db`)
                     }).catch(err => {
                       console.log(`Failed to delete transactions cache object ${cacheTransactionsObject.name} from cache db`)
                     });
                   }).catch(err => {
                     console.log(`Failed to delete transactions cache object: ${cacheTransactionsObject.name} from cache db`);
                   });

                 }).catch(err => {

                   console.log(`Failed to add ${transactionsObject.name} : transaction in firebase transactions' node`);


                 });
               }).catch(err => {
                 console.log(`Failed to place ${transactionsObject.name} in transactionsdb`);
               });

             }).catch(err => {
               console.log(`Failed to put ${cacheTransactionsObject.name} in cachedb ${err}`);
             });

           }).catch(err => {
             console.log(`Failed to update your savingsObject ${savingsObject.name} in savingsdb ${err}`)
           });

         }).catch(err => {
           console.log(`Didn't get ${savingsObject.name} in savingsdb ${err}`);
         });
       }).catch(err => {
         console.log(`Failed to place cacheSavingsObject in cachedb on update ${err}`)
       });

     })







    },
    deleteSavings: function({state, commit, dispatch},payload){
      // Payload is the savings

         savingsdb.get(payload._id).then(doc => {

            savingsdb.remove(doc).then(() => {
             console.log(`Successfully deleted ${payload.name} from savings db`);

             // Takes care of transactions too on the state side
              /// Taking care of transactions in the transactionsdb side
              let transactionsArray = [...state.transactionsArray];


              let transactions = transactionsArray.filter(transaction => {
                return transaction.name === payload.name;
              })

              console.log(state.transactionsArray);
              console.log(transactions);

              transactions.forEach((transaction, index, array)=> {
                transactionsdb.get(transaction._id).then(doc => {
                  return transactionsdb.remove(doc);
                }).then(() => {

                  if(index === array.length -1){
                    //Do something like stop the progress bar
                    /// Commit 'delete Record after all transactions have been deleted from transactionsdb'
                    commit('deleteRecord', payload);
                  }
                }).catch(err => {
                  console.log(`Failed to remove transaction number: ${transaction._id} ${err}`);
                });
              });




           }).catch(err => {
             console.log(`Failed to delete savings object: ${payload.name} from savings db`)
           });
      }).catch(err => {
        console.log(`Failed to get the savings:${payload.name} from savingsdb`);
      });

    },
    delete: function({commit, state, dispatch},payload){
      /// Payload should be the savings object
      console.log(payload);

      payload = {...payload};


      let requestObject = {
        _id: `delete_${payload.name}`,
        name: payload.name,
        request: 'delete',
        realID: payload._id
      }

        cachedb.put(requestObject).then(() => {
        // Successful

        // Delete from our savings and transactionsdb
          /// The payload is the saving Object
        dispatch('deleteSavings', payload);

        firebase.database().ref(`/${state.userID}/savings/`).child(payload._id).remove().then(() => {

          firebase.database().ref(`/${state.userID}/`).child('transactions').orderByChild('name').equalTo(payload.name).once('value', function(snapshot) {
            let data = snapshot.val();

            console.log(data);

            let size = snapshot.numChildren();
            let counter = 1;

            snapshot.forEach((child) => {
              let key = child.key;
              firebase.database().ref(`/${state.userID}/transactions/`).child(key).remove().then(() => {
                counter++;
                if(counter === size) {
                  /// Can place a stop loading for progress stuff here
                  cachedb.get(requestObject._id).then(doc => {
                    cachedb.remove(doc) /// By faith
                  })
                }
              });
            })
          });

        });

      }).catch(err => {
        console.log('Failed to place delete request in cache db' + err);
      });

    },
    addSavings: function({commit, state, dispatch}, payload){

      /// Updating names array and savings array
      let inputObject = {
         current: Number(payload.startingValue),
         target: Number(payload.target),
         name: payload.title
      };
      commit('addInputs', inputObject);
      /// Updating names array and savings array


      /// Calculate the chart object using the Updated state inputsArray/namesArray
      let inputsArray = [...state.inputsArray];
      let namesArray = [...state.namesArray];
      let chartObject = methodChooser(payload.choice, inputsArray,namesArray);
      /// Calculate the chart object using the Updated state inputsArray/namesArray

      /// Create savings and transaction object
      let transactionType;
      if(Number(payload.startingValue) > 0){
        transactionType = 'first deposit';
      } else {
        transactionType = 'added';
      }

      let dateToday = today.toLocaleDateString("en-US", options);

      let savingsObject = {
          _id: String(state.currentSavingsIndex + 1),
          name: payload.title,
          dateAdded: dateToday,
          adviseType: chartObject.typeArray[chartObject.typeArray.length - 1],
          currentAdvise: "",

          lastTransactionType: transactionType,
          lastTransactionAmount: payload.startingValue,
          lastTransactionDate: dateToday,
          lastTransactionID: "noID",

          prevAmount: 0,
          currentAmount: payload.startingValue,
          targetAmount: payload.target
      };

      let transactionsObject = {
        _id: String(state.currentTransactionsIndex + 1),
        name: payload.title,
        transactionType: transactionType,
        transactionDate: dateToday,
        transactionID: "noID",
        transactionAmount: payload.startingValue,
        prev: 0,
        current: payload.startingValue,
        target: payload.target
      };
      /// Create savings and transaction object

      /// Put the objects in the cachedb and transactionsdb, savingsdb
      let cacheSavingsID = `add_savings_${savingsObject._id}`;
      let cacheTransactionsID = `add_transactions_${transactionsObject._id}`;

      let cacheSavingsObject = Object.assign({}, savingsObject);
      cacheSavingsObject._id = cacheSavingsID;
      cacheSavingsObject.request = 'add';

      let cacheTransactionsObject = Object.assign({}, transactionsObject);
      cacheTransactionsObject._id = cacheTransactionsID;
      cacheTransactionsObject.request = 'add';

      /// Order is Savings First, then Transactions Next
      cachedb.put(cacheSavingsObject).then(() => {
      console.log('Just placed new savings object to cachedb');
      /// Add savings object to the savingsArray
      commit('addSavings', savingsObject);
      /// Put object in savings cache
      savingsdb.put(savingsObject).then(() => {
        console.log('Just placed new savings object in savingsdb');
         commit('setSavingsIndex', state.currentSavingsIndex + 1);

        firebase.database().ref(`/${state.userID}/savings/${savingsObject._id}/`).set(savingsObject).then(() => {
          console.log(`Successfully put ${savingsObject.name} in firebase`);

          cachedb.get(cacheSavingsObject._id).then(doc => {
              cachedb.remove(doc).then(() => {
                console.log(`Successfully removed ${cacheSavingsObject.name} : savings from cachedb`);
              }).catch(err => {
                console.log(`Failed to remove ${cacheSavingsObject.name} : savings from cachedb`);
              });
          }).catch(err => {
            console.log(`Failed to delete ${cacheSavingsObject.name} : savings cached from cachedb`);
          });

        }).catch(err => {
          console.log(`Firebase failed to put ${savingsObject.name} : savings in firebase`);
        });

      }).catch(err => {
        console.log('Failed to put the new savings object in savingsdb - in cachedb area ' + err);
      });


      /// Transactions area in cachedb
      cachedb.put(cacheTransactionsObject).then(() => {
        console.log(`Successfully put ${cacheTransactionsObject.name} : transaction in cachedb`);
        commit('setTransactionsIndex', state.currentTransactionsIndex + 1);
        commit('addTransactions', transactionsObject);

        dispatch('setChartObject', state.currentPlan);


        /// Put in transactionsdb
        transactionsdb.put(transactionsObject).then(() => {
          console.log(`Successfully placed ${transactionsObject.name} in transactionsdb`);

          firebase.database().ref(`/${state.userID}/transactions/${transactionsObject._id}/`).set(transactionsObject).then(() => {

            cachedb.get(cacheTransactionsObject._id).then(doc => {
              cachedb.remove(doc).then(() => {
                console.log(`Successfully deleted transactions cache object ${cacheTransactionsObject.name} from cache db`)
              }).catch(err => {
                console.log(`Failed to delete transactions cache object ${cacheTransactionsObject.name} from cache db`)
              });
            }).catch(err => {
              console.log(`Failed to delete transactions cache object: ${cacheTransactionsObject.name} from cache db`);
            });

          }).catch(err => {

            console.log(`Failed to add ${transactionsObject.name} : transaction in firebase transactions' node`);


          });
        }).catch(err => {
          console.log(`Failed to place ${transactionsObject.name} in transactionsdb`);
        });

      }).catch(err => {
        console.log(`Failed to put ${cacheTransactionsObject.name} in cachedb`);
      });




      }).catch(err => {
        console.log('Failed to place Savings object in cachedb' + err);
      });



    },
    setUID: function({commit},payload){
      commit('changeUID',payload);
    },
    auth: function({
      commit,
      state,
      dispatch
    }) {
      let status = true // Decider
      state.type = 'progress'
      state.message = 'Please wait...'
      state.isLoading = true // Opener of a dialog, specify which dialog
      setTimeout(() => {
        commit('changeAuthStatus', status)
        state.isLoading = false

        setTimeout(() => {
          if (!status) {
            dispatch('showDialog', {
              type: 'message',
              message: 'Some error occurred'
            })
          }
        }, 100)
      }, 3000)
    },
    outsideAuth: function ({
      commit
    }, payload) {
      commit('changeAuthStatus', payload)
    },
    signup: function ({
      commit,
      dispatch
    }, payload) {
      dispatch('showDialog', {
        type: 'progress',
        message: 'Please wait ...'
      })
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password).then(resp => {
        commit('changeLoadingState')
        commit('changeAuthStatus', true)
        const newUser = {
          id: resp.user.uid
        }
        commit('setUser', newUser)
      }).catch(err => {
        commit('changeLoadingState')
        commit('changeAuthStatus', false)
        setTimeout(() => {
          dispatch('showDialog', {
            type: 'messageOnly',
            message: err.message
          })
        }, 100)
      })
    },
    login: function ({
      commit,
      dispatch
    }, payload) {
      dispatch('showDialog', {
        type: 'progress',
        message: 'Please wait ...'
      })
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password).then(resp => {
        commit('changeLoadingState')
        commit('changeAuthStatus', true)
        const newUser = {
          id: resp.user.uid
        }
        commit('setUser', newUser)
      }).catch(err => {
        commit('changeLoadingState')
        commit('changeAuthStatus', false)
        setTimeout(() => {
          dispatch('showDialog', {
            type: 'messageOnly',
            message: err.message
          })
        }, 100)
      })
    },
    logout: function ({
      commit
    }) {
      firebase.auth().signOut()
      commit('logout')
    },
    inStage1: function ({
      commit
    }) {
      commit('stage1True')
    },
    inStage2: function ({
      commit
    }) {
      commit('stage1False')
    },
    changeLoadAction: function ({
      commit
    }) {
      commit('changeLoadingState')
    },
    showDialog: function ({
      commit
    }, payload) {
      commit('showMessageDialog', payload)

      if (payload.type === 'messageOnly') {
        setTimeout(() => {
          commit('changeLoadingState')
        }, 2500)
      }

    },
    stopLoading: function({commit}) {
      commit('changeLoadingState');
    }
  },
  getters: {
    getCurrentTheme(state){
      return state.lightTheme;
    },
    getCurrentPlanIsSet(state){
      return state.currentPlan !== '';
    },
    getCurrentPlan(state){
      return state.currentPlan;
    },
    getChartObject(state){
      return state.fullObject;
    },
    getIndex(state) {
      return {
        savingsIndex : state.currentSavingsIndex,
        transactionsIndex: state.currentTransactionsIndex
      }
    },
    getInputsArray(state) {
      return JSON.parse(JSON.stringify(state.inputsArray));
    },
    getNamesArray(state) {
      return state.namesArray;
    },
    getSavingsArray(state) {
      return JSON.parse(JSON.stringify(state.savingsArray));
    },
    getTransactionsArray(state) {
      return JSON.parse(JSON.stringify(state.transactionsArray));
    },
    authStatus(state) {
      return state.isAuth
    },
    loadStatus(state) {
      return state.isLoading
    },
    firstStageCheck(state) {
      return state.isInFirstStage
    },
    getType(state) {
      return state.type
    },
    getMessage(state) {
      return state.message
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js